import React, { FC, ReactNode } from "react";

interface LoadingProps {
  loading?: boolean;
  message?: ReactNode;
}

const Loading: FC<LoadingProps> = ({ loading = true, message }) => {
  return (
    <div className={`loading-wp ${loading ? " is-loading" : ""}`}>
      {message && <div className="loading-message">{message}</div>}
    </div>
  );
};

export default Loading;
